import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sBrandControllerEndpoint = 'Brand';
const sCarModelControllerEndpoint = 'CarModel';
const sSaleChannelControllerEndpoint = 'SalesChannel';
const sNegotiationLotStateControllerEndpoint = 'NegotiationLotState';
const sRappelControllerEndpoint = 'Rappel';
const sColorControllerEndpoint = 'Color';
const sExtensionReasonsControllerEndpoint = 'ExtensionReasons';
const sCancellationReasonsControllerEndpoint = 'CancellationReasons';
const sReservationStateControllerEndpoint = 'ReservationState';
const sReservationTypeControllerEndpoint = 'ReservationType';
const sLPGainAPIControllerEndpoint = 'LPGain';


export class DropdownListAPI {

  //@param {number} type Number that distinguishes the type of brands to fetch: 0 - New cars; 1 - Used cars; 2 - Both
  getAllBrands(type) {
    return axios.get(getBackendURL() + sBrandControllerEndpoint + '/GetBrandsByType?type=' + type);
  }

  getAllActiveBrandsForSF() {
    return axios.get(getBackendURL() + sBrandControllerEndpoint + '/GetActiveBrandsForSF');
  }

  getAllCarModelsByBrand(brandId, type) {
    let params = {
      brandId: brandId,
      type: type,
    }
    return axios.get(getBackendURL() + sCarModelControllerEndpoint + '/GetModelsByBrandAndType', { params });
  }

  getAllActiveCarModelsByBrandForSF(brandId) {
    let params = {
      brandId: brandId
    }
    return axios.get(getBackendURL() + sCarModelControllerEndpoint + '/GetActiveModelsByBrandForSF', { params });
  }

  getAllSalesChannels() {
    return axios.get(getBackendURL() + sSaleChannelControllerEndpoint + '/GetAllSalesChannels');
  }

  getSaleChannelsByUser() {
    return axios.get(getBackendURL() + sSaleChannelControllerEndpoint + '/GetSalesChannelsByUser');
  }

  getAllLotStates(moduleName, isNegotiation) {
    this.params = {
      moduleName: moduleName,
      isNegotiation: isNegotiation
    }
    return axios.get(getBackendURL() + sNegotiationLotStateControllerEndpoint + '/GetLotStateList', { params: this.params });
  }

  getAllRappelTypes() {
    return axios.get(getBackendURL() + sRappelControllerEndpoint + '/GetRappelTypeList');
  }

  getAllColors() {
    return axios.get(getBackendURL() + sColorControllerEndpoint + '/GetColorList');
  }

  getAllExtensionReasons() {
    return axios.get(getBackendURL() + sExtensionReasonsControllerEndpoint + '/GetExtensionReasonList');
  }

  getAllCancellationReasons() {
    return axios.get(getBackendURL() + sCancellationReasonsControllerEndpoint + '/GetCancellationReasonList');
  }

  getAllReservationStates() {
    return axios.get(getBackendURL() + sReservationStateControllerEndpoint + '/GetReservationStateList');
  }

  getAllReservationTypes() {
    return axios.get(getBackendURL() + sReservationTypeControllerEndpoint + '/GetReservationTypeList');
  }

  getAllLPGains() {
    return axios.get(getBackendURL() + sLPGainAPIControllerEndpoint + '/GetLPGainsList');
  }

}

export default DropdownListAPI


// WEBPACK FOOTER //
// ./src/API/DropdownListAPI.js